module.exports = __webpack_public_path__ + "img/Lab_Book_Icon_Bold.64845a03.svg";